import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import './main.less';
import { actions, selectors } from './';

import renderViewState from '../../../shared/render-views-state';
import Table from '../components/table/main';

import PageContainer from '../../../shared/page-container/main';
import tabs from '../../tabs';

const Main = renderViewState((props) => (
	<PageContainer name='Missions' tabs={tabs}>
		<div className='container__content goods-list'>

			<div className='ui-control-bar'>
				<div className='ui-control-bar__item'>
					<div className='ui-control-bar__item-position'>
						{props.can('edit') && (
							<Link
								to='/achievements/edit/'
								className='ui-btn ui-btn-primary ui-btn-sign__plus'
							>{props.intl('Add achievement')}</Link>
						)}
					</div>
				</div>

			</div>
			<Table
				{...props}
				isIndexing
				narrow
			/>
		</div>
	</PageContainer>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		error:selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/list/main.js